import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectUserProfile, selectIsAuthenticated } from 'store/slices/user.slice';
import { AnalyticsService } from './analyticsService';
import { ANALYTICS_USER_PROPERTIES } from './analyticsEvents';

export default function AnalyticsIdentitySync() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const profile = useSelector(selectUserProfile);

  useEffect(() => {
    if (isAuthenticated && profile?.id) {
      AnalyticsService.setUserId(String(profile.id));
      AnalyticsService.setUserProperties({
        [ANALYTICS_USER_PROPERTIES.KYC_STATUS]: profile.kycStatus ?? 'unknown',
        [ANALYTICS_USER_PROPERTIES.RA_STATUS]: profile.raStatus ?? 'unknown',
      });
    } else if (!isAuthenticated) {
      AnalyticsService.setUserId(null);
    }
  }, [isAuthenticated, profile?.id, profile?.kycStatus, profile?.raStatus]);

  return null;
}
